export default __webpack_public_path__ + "static/SeoGenericMakeModelBlock-0709d9b4d68737bb589ca25b17abff56.jpg";